// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"66":"afc7f0d6","803":"75ac8f2a"}[chunkId] + ".css";
};